<template>
  <div id="loading" :style="bgLine">
    <div class="wrap">
      <div class="txt">NOW LOADING...</div>
      <div class="per">{{ this.parcentage }}%</div>
      <div class="gaugeWrap" :style="gaugeFrame">
        <div class="gauge"></div>
        <div class="gauge"></div>
        <div class="gauge"></div>
        <div class="gauge"></div>
        <div class="gauge"></div>
        <div class="gauge"></div>
        <div class="gauge"></div>
        <div class="gauge"></div>
        <div class="gauge"></div>
        <div class="gauge"></div>
        <div class="gauge"></div>
        <div class="gauge"></div>
        <div class="gauge"></div>
        <div class="gauge"></div>
        <div class="gauge"></div>
        <div class="gauge"></div>
        <div class="gauge"></div>
        <div class="gauge"></div>
      </div>
      <div class="charaWrap">
        <div class="chara1"><img :src="`${publicPath}img/top/load_chara1.gif`" alt=""></div>
        <div class="chara2"><img :src="`${publicPath}img/top/load_chara2.gif`" alt=""></div>
      </div>
    </div>
  </div>
</template>

<script>
  import _$ from 'jquery'

  export default {
    name: 'Story',
    components: {
    },
    props: {
    },
    data(){
      return {
        publicPath: process.env.BASE_URL,
        bgLine: {
          backgroundImage: 'url(./img/top/top_checkline.png),url(./img/top/top_checkline.png)',
        },
        gaugeFrame: {
          backgroundImage: 'url(./img/top/load_gaugeframe.png)'
        },
        progressCount: 0,
        parcentage: 0
      }
    },
    mounted() {
      
    },
    destroyed () {
    },
    watch: {
      progressCount(newValue){
        this.parcentage = Math.round(newValue)
        for(let i=0; i < Math.round(newValue / 5.555); i++){
          _$('.gaugeWrap .gauge').eq(i).addClass('show')
        }
        if(this.parcentage === 100){
          this.loadComplete();
          _$('#loading .wrap .chara1').hide()
          _$('#loading .wrap .chara2').show()
        }
      }
    },
    computed: {

    },
    methods: {
      loadComplete(){
        this.timer = setTimeout(function(){
          this.$emit('loadComplete');
          clearTimeout(this.timer)
        }.bind(this), 1800)  
      }
    }
  }
</script>

<style lang="scss" scoped>
  #loading {
    width: 100%;
    height: 100%;
    background-color: #000;
    background-position: top left, bottom left;
    background-repeat: repeat-x, repeat-x;
    background-size: toVW(72) auto, toVW(72) auto;
    display: flex;
    justify-content: center;
    align-items: center;

    .wrap {
      padding: toVW(10) 0 0;
      position: relative;

      .txt {
        font-size: toVW(68);
        text-align: center;
        margin-bottom: toVW(48);
        letter-spacing: .05em;
      }
      .per {
        font-size: toVW(120);
        text-align: center;
        margin-bottom: toVW(48);
        letter-spacing: .05em;
      }

      .gaugeWrap {
        background-repeat: no-repeat;
        background-size: contain;
        width: toVW(592);
        height: toVW(92);
        padding: toVW(19) toVW(30);
        display: flex;
        justify-content: space-between;
        align-items: center;

        .gauge {
          background: $COLOR_PINK01;
          width: toVW(22);
          height: toVW(54);
          opacity: 0;

          &.show {
            opacity: 1;
          }
        }
      }

      .charaWrap {
        width: toVW(381);
        height: toVW(238);
        margin: toVW(115) auto 0 toVW(76);
      }

      .chara1 {
        width: toVW(381);
        height: toVW(238);
      }

      .chara2 {
        width: toVW(264);
        height: toVW(238);
        margin: 0 0 0 toVW(117);
        display: none;
      }
    }
  }
</style>